import React from 'react';

export default function CompletionCheckMark({ isHighlighted = false }) {
    // Only render something if highlighted (error state)
    if (!isHighlighted) {
        return null; // Return nothing - completely invisible
    }

    return (
        <div className='CompletionCheckMark'>
            <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 8v4m0 4h.01M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"
                    stroke="var(--danger)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
}